import "./PeerReviewerServiceEvalution.scss"
import { PeerReviewerServiceProvider } from "../../features/PeerReviewerServiceForm/ServiceContext";
import ServicePeerReviewerForm from "../../features/PeerReviewerServiceForm/ServicePeerReviewerForm";
const PeerReviewerServiceEvaluation = () => {
  return (
    <PeerReviewerServiceProvider>
      <div className="page-container">
        <ServicePeerReviewerForm />
      </div>
    </PeerReviewerServiceProvider>
  );
};
export default PeerReviewerServiceEvaluation;
